import React from 'react';
import Link from 'next/link';
import { getProductDetailUrl } from 'utils/urlHelpers/urlHelpers';
import { Styles } from './styles';
import { Text } from 'atoms/Text/Text';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { Highlight } from '../Highlight/Highlight';
import { AlgoliaProduct } from 'models/products';
import { TEST_IDS } from 'constants/testIds';
import { NextImagePlaceholder } from 'features/products/components/NextImagePlaceholder/NextImagePlaceholder';
import { logTrackingEvent, CustomEventName } from 'services/analytics';
import { cleanDataAnalytics } from 'services/analytics/events';

interface SearchResultProps {
  hit: AlgoliaProduct;
}

export const SearchResult: React.FC<SearchResultProps> = ({ hit }) => {
  const viewProductPage = (hit: AlgoliaProduct) => {
    logTrackingEvent({
      name: CustomEventName.Product_Search_Click,
      data: cleanDataAnalytics(hit),
    });
  };
  return (
    <Link href={getProductDetailUrl(hit.urlSlug)}>
      <a onClick={() => viewProductPage(hit)}>
        <Styles.ResultWrapper>
          <Styles.ImageContainer>
            <NextImagePlaceholder
              height="130"
              width="130"
              layout="intrinsic"
              src={hit.skuImage}
              alt={hit.skuName}
            />
          </Styles.ImageContainer>
          <div>
            <Highlight attribute="productName" hit={hit} />
            <Text.caption2
              data-testid={TEST_IDS.products.searchResult.name}
              color={defaultTheme.colors.secondaryGrey}
            >
              {hit.skuName}
            </Text.caption2>
            {hit.skus?.length && (
              <Styles.MultiVariantsWrapper>
                <Text.caption3
                  data-testid={TEST_IDS.products.searchResult.moreVariantsText}
                  color={defaultTheme.colors.darkGrey}
                >
                  Multiple variants available
                </Text.caption3>
              </Styles.MultiVariantsWrapper>
            )}
          </div>
        </Styles.ResultWrapper>
      </a>
    </Link>
  );
};
